import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Separator } from '@/components/ui/separator';

const footerSections = [
  {
    title: 'Certifications',
    links: [
      { to: '/ipcf', label: 'Certification Framework (IPCF)' },
      { to: '/faculty/aesthetic-medicine', label: 'CBEAM - Aesthetic Medicine' },
      { to: '/faculty/longevity-medicine', label: 'CBELM - Longevity Medicine' },
      { to: '/faculty/regenerative-medicine', label: 'CBERM - Regenerative Medicine' },
      { to: '/examination-pathways', label: 'Examination Pathways' },
      { to: '/verification', label: 'Verify Certificate' },
    ]
  },
  {
    title: 'Examinations & Standards',
    links: [
      { to: '/examination-structure', label: 'Examination Structure' },
      { to: '/examination-framework', label: 'Examination Framework' },
      { to: '/candidate-handbook', label: 'Candidate Handbook' },
      { to: '/osce', label: 'OSCE Structure' },
    ]
  },
  {
    title: 'Organisation',
    links: [
      { to: '/about', label: 'About IMCAC' },
      { to: '/governance-structure', label: 'Governance Structure' },
      { to: '/governance', label: 'Governance Framework' },
      { to: '/ethics', label: 'Ethics & Integrity' },
      { to: '/independence-policy', label: 'Independence Policy' },
      { to: '/policies', label: 'Policies' },
      { to: '/contact', label: 'Contact' },
    ]
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#1B2A4A] text-white" data-testid="main-footer">
      <div className="imcac-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_cbeam-portal/artifacts/6xytjpjs_IMCAC%20%287%29.png"
                alt="IMCAC Logo"
                className="h-12 w-12 rounded-sm object-contain"
              />
              <div>
                <p className="text-base font-bold font-heading tracking-tight">IMCAC</p>
                <p className="text-[10px] text-slate-300 tracking-wider uppercase">International Medical Competency Accreditation Council</p>
              </div>
            </div>
            <p className="text-sm text-slate-300 leading-relaxed mb-4">
              Independent Competency Assessment & Certification Board
            </p>
            <p className="text-xs text-slate-400 leading-relaxed mb-4">
              Certifications are awarded based on successful completion of competency-based assessments and do not constitute a license to practice.
            </p>
            <div className="space-y-2 text-sm text-slate-300">
              <p className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#C5A572]" /> admin@imcac.org</p>
              <p className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#C5A572]" /> +91 8382828215</p>
              <p className="flex items-start gap-2"><MapPin className="h-4 w-4 text-[#C5A572] flex-shrink-0 mt-0.5" /> Unit 413, Swaroop Aditya Avenue, Marol Pipeline Rd, J B Nagar, Andheri East, Mumbai, Maharashtra 400099, India</p>
            </div>
          </div>
          {footerSections.map((section) => (
            <div key={section.title}>
              <p className="text-xs font-bold uppercase tracking-widest text-[#C5A572] mb-4">{section.title}</p>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="text-sm text-slate-300 hover:text-white transition-colors" data-testid={`footer-link-${link.to.slice(1).replace(/\//g, '-')}`}>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <Separator className="my-10 bg-slate-600/30" />

        <div className="bg-[#152039] rounded-sm p-4 mb-8">
          <p className="text-xs text-slate-400 leading-relaxed">
            <span className="text-[#C5A572] font-semibold">Important Notice:</span> IMCAC is an independent competency assessment and certification body. IMCAC does not provide training, workshops, academic programs, or medical licenses. Certification does not replace professional registration requirements imposed by national regulatory authorities. Certifications are awarded based on successful completion of competency-based assessments and do not constitute a license to practice. IMCAC is a registered Non-Profit Organisation under Section 8 of the Companies Act, India.
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-400">
          <p>&copy; {new Date().getFullYear()} International Medical Competency Accreditation Council. All rights reserved.</p>
          <div className="flex gap-4">
            <Link to="/policies" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/policies" className="hover:text-white transition-colors">Terms of Use</Link>
            <Link to="/governance" className="hover:text-white transition-colors">Data Protection</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
